import { render, staticRenderFns } from "./materialapoyo.vue?vue&type=template&id=7b8c4022"
import script from "./materialapoyo.vue?vue&type=script&lang=js"
export * from "./materialapoyo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports